import React, { useEffect, useState } from 'react';

interface EditableCellProps {
  defaultValue: string;

  editComponent: React.FC<{
    style: React.CSSProperties;
    onChange: (value: string) => void;
  }>;
  editComponentProps: any;

  onConfirm: (value: string) => void;
}

const EditableTableCell = ({
  defaultValue,
  editComponent: EditComponent,
  editComponentProps,
  onConfirm,
}: EditableCellProps) => {
  const [value, setValue] = useState(defaultValue);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (!editMode) onConfirm(value);
  }, [editMode]);

  useEffect(() => {
    const handleMouseDown = () => setEditMode(false);
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, []);

  return (
    <td
      role="presentation"
      tabIndex={-1}
      onMouseDown={(e) => e.stopPropagation()}
      onDoubleClick={() => setEditMode(true)}
    >
      {editMode ? (
        <EditComponent
          style={{
            border: 'none',
            background: 'transparent',
          }}
          onChange={setValue}
          {...editComponentProps}
        />
      ) : (
        value
      )}
    </td>
  );
};

export default EditableTableCell;
